<json-editor [options]="editorOptions()" (change)="handleChange($event)" [data]="initialValue || {}"></json-editor>
